<template>
    <div>
        <v-card v-show="!showItemPicker">
            <v-toolbar flat color="info" height="40" >
                <v-toolbar-title>
                    {{title}}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon color="primary" @click.prevent="closeItemEdit()">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-form ref="quoteItemform" v-model="itemFormValid" lazy-validation>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.itemCategory" 
                                label="Category"
                                ></v-text-field>
                        </v-flex>

                        <v-flex xs12>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.itemNumber" 
                                label="Item No"
                                :readonly="true"
                                type="text"
                                >
                                    <v-menu
                                    slot="append-outer"
                                    style="top: -12px"
                                    offset-y
                                    >
                                        <v-btn slot="activator" color="primary" @click="showItemPicker=true">
                                            Pick Item
                                        </v-btn>

                                    </v-menu>
                                </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.itemDesc" 
                                label="Item Desc."
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field 
                                :rules="[rules.required]"
                                v-model="itemData.sortNo" 
                                type="number"
                                label="Sort No."
                                ></v-text-field>
                        </v-flex>
                        <v-flex xs4>
                            <v-text-field 
                                v-model="itemData.itemUnit" 
                                label="Item Unit"
                                disabled
                                ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout>
                        <v-flex xs-12 pt-3 class="text-xs-center">
                            <v-btn :disabled="!itemFormValid" @click="onSaveItem">Submit</v-btn>
                        </v-flex>
                    </v-layout>

                </v-card-text>

            </v-form>
<!-- 
            {{itemData}}
            {{ originalItemData }} -->
        </v-card>
            <ctlItemSearch @onItemPicked="onItemPicked" v-show="showItemPicker"></ctlItemSearch>
    </div>
</template>
<script>
import ctlItemSearch from '@/components/ctlItemSearch'
import { mapGetters, mapActions } from "vuex";

export default {
    props: ['originalItemData'],
    components: {
        ctlItemSearch
    },
    data () {
        return {
            itemData: {},
            showItemPicker: false,
            itemFormValid: false,
            rules: {
                required: v => !!v || "This field is required"
            },
        }
    },
    computed: {
        isNew () {
            return !this.originalItemData.id
        },
        title () {
            return this.isNew? 'Add Item' : 'Edit Item'
        },
        // itemData () {
        // },
        // isCustomItem () {
        //     if (this.isNew) {
        //         return false
        //     } else {
        //         // if it has itemId, it is an HealthMark inventory item
        //         return !!this.originalItemData.itemId
        //     }
        // },
    },
    methods: {
        ...mapActions('adminQteTemplate', [
            'insertQuoteTemplateItem',
        ]),
        onItemPicked (itemDataPicked) {
            this.showItemPicker = false
            if(itemDataPicked) {
                console.log(itemDataPicked);
                this.itemData = Object.assign({}, this.itemData, {
                    itemNumber: itemDataPicked.itemNumber,
                    itemDesc: itemDataPicked.description,
                    itemUnit: itemDataPicked.unit,
                    itemId: itemDataPicked.itemId,
                })
            }
        },
        closeItemEdit () {
            this.$emit('onSaveItem', null)
        },
        // if itemDataToSave == null,it means we will close this popup
        async onSaveItem () {
            // console.table(itemDataToSave)
            if (this.$refs.quoteItemform.validate()) {
                // console.log('onItemPicked called')
                //if quote has id, in our system, it means we will save item to database. 
                if(!this.itemData.id) {
                    var result = await this.insertQuoteTemplateItem(this.itemData)
                }
                this.$emit('onSaveItem', this.itemData)
                //reset data for reuse next time
                this.itemData = {}
            }
        }
    },
    watch: {
        originalItemData (value) {
            // console.log('originalitemchanged')
            // console.table(value)
            // if (value.itemId) {
            //     this.itemData = {}
            //     this.isCustomItem = false
            // } else {
                this.itemData = Object.assign({}, this.originalItemData)
                // if it has itemId, it is an HealthMark inventory item
console.log("this.itemData")
console.log(this.itemData)
            // }

        }
    },
    created() {

    }
}
</script>
